module.exports = __webpack_public_path__ + "img/trade-02.ce1f4c59.svg";